import * as Yup from 'yup';
import { DictionaryObject } from '@eas/common-web';

export function useValidationSchema() {
  return Yup.object<DictionaryObject>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
